<div class="outer-div" [ngClass]="mode">
  <!-- =====================================================
         HEADER
    ====================================================== -->
  <div class="label-bar">
    <!-- TITLE -->
    <div class="header-section">
      <label i18n="@@spmsUserReg" class="header-label-text">
        IMDRF Browser
      </label>
    </div>

    <span class="example-spacer"></span>

    <!-- TOOLS -->
    <div class="toolbar-section">
      <!-- ANNEX -->
      <mat-form-field appearance="outline">
        <mat-label>Annex</mat-label>

        <mat-select
          [(ngModel)]="activeTab"
          (selectionChange)="selectTab($event.value)"
        >
          <mat-option *ngFor="let tab of tabs" [value]="tab">
            Annex {{ tab }}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <!-- RELEASE -->
      <div style="display:flex;  gap:2rem">
        <mat-form-field appearance="outline" >
        <mat-label>Release Year</mat-label>

        <mat-select
          [(ngModel)]="releaseYear"
          (selectionChange)="selectLatestVersion($event.value)"
        >
          <mat-option *ngFor="let tab of releaseYears" [value]="tab">
            {{ tab }}
          </mat-option>
        </mat-select>
      </mat-form-field>
<!-- Split Dropdown Download Button -->
<div class="split-download-btn" [class.open]="showDropdown" #dropdownRef>
  <!-- Main button: downloads the first/default file directly -->
  <!-- <button 
    class="split-main-btn"
    [disabled]="!activeTab || !releaseYear || metadataFiles.size === 0 || isDownloading"
    (click)="onMainDownloadClick()"
    title="Download Change Request Log">
    <i class="fas fa-download"></i>
    <span>Download</span>
  </button> -->

  		  <app-common-button
          label="Download"
          title="Download "
          [disabled]="!activeTab || !releaseYear || metadataFiles.size === 0 || isDownloading"
		      icon="fas fa-download"
          [buttonId]="1111"
			    width="110px"
          [critical]="false"
          (clicked)="toggleDropdown($event)"
           style="margin-left: 6px;margin-right:6px;"
          >
          </app-common-button>

  <!-- Chevron toggle -->
  <!-- <button 
    class="split-chevron-btn"
    [disabled]="!activeTab || !releaseYear || metadataFiles.size === 0 || isDownloading"
    (click)="toggleDropdown($event)"
    title="See all files">
    <i class="fas fa-chevron-down" [class.rotated]="showDropdown"></i>
  </button> -->

  <!-- Dropdown panel -->
  <div class="split-dropdown-panel" *ngIf="showDropdown">
    <div class="split-dropdown-header">
      {{ metadataFiles.size }} file{{ metadataFiles.size > 1 ? 's' : '' }} available for  : {{ releaseYear }}
    </div>

    <div *ngIf="metadataFiles.size === 0" class="split-dropdown-empty">
      No files available for this release
    </div>

    <button
      *ngFor="let entry of metadataFiles | keyvalue"
      class="split-dropdown-item"
      (click)="selectAndDownload(entry.key, entry.value)"
      [disabled]="isDownloading">

      <div class="split-dropdown-item-icon" [ngClass]="entry.key === 'releaseNotes' ? 'icon-txt' : 'icon-xlsx'">
        <i [class]="entry.key === 'releaseNotes' ? 'fas fa-file-alt' : 'fas fa-file-excel'"></i>
      </div>

      <div class="split-dropdown-item-text">
        <span class="split-dropdown-item-title">
          {{ entry.key === 'releaseNotes' ? 'Release Notes' : 'Change Request Log' }}
        </span>
        <span class="split-dropdown-item-sub">
          {{ entry.key === 'releaseNotes' ? '.txt' : '.xlsx' }} · Release {{ releaseYear }}
        </span>
      </div>

      <span 
        *ngIf="isDownloading && selectedFileType === entry.key" 
        class="spinner-border spinner-border-sm text-primary" 
        role="status">
      </span>
      <i 
        *ngIf="!isDownloading || selectedFileType !== entry.key" 
        class="fas fa-download split-dropdown-item-dl">
      </i>
    </button>
  </div>
</div>
      </div>
    </div>
  </div>

  <!-- =====================================================
         DETAILS CARD
    ====================================================== -->
  <!-- <div class="details-wrapper" *ngIf="selectedAnnexDetails">
    <div class="details-card container-fluid">
      <div class="row">
       
        <div class="col-lg-4 col-md-6 detail-column">
          <div class="info-row">
            <span class="info-label"> Code: </span>

            <span
              class="info-value code-value"
              [attr.title]="selectedAnnexDetails?.code"
            >
              {{ selectedAnnexDetails?.code || "N/A" }}
            </span>
          </div>

          <div class="info-row">
            <span class="info-label"> Name: </span>

            <span
              class="info-value truncate"
              [attr.title]="selectedAnnexDetails?.name"
            >
              {{ selectedAnnexDetails?.name || "N/A" }}
            </span>
          </div>
        </div>

       
        <div class="col-lg-4 col-md-6 detail-column">
          <div class="info-row">
            <span class="info-label"> Status: </span>

            <span
              class="status-badge"
              [ngClass]="getStatusClass(selectedAnnexDetails?.status)"
            >
              {{ selectedAnnexDetails?.status || "N/A" }}
            </span>
          </div>

          <div class="info-row">
            <span class="info-label"> Status Description: </span>

            <span
              class="info-value truncate"
              [attr.title]="selectedAnnexDetails?.statusDescription"
            >
              {{ selectedAnnexDetails?.statusDescription || "N/A" }}
            </span>
          </div>
        </div>

  
        <div class="col-lg-4 col-md-12 detail-column">
          <div class="info-row">
            <span class="info-label"> Non IMDRF Code: </span>

            <span
              class="info-value truncate"
              [attr.title]="selectedAnnexDetails?.nonImdrfCode"
            >
              {{ selectedAnnexDetails?.nonImdrfCode || "N/A" }}
            </span>
          </div>

          <div class="info-row">
            <span class="info-label"> Definition: </span>

            <span
              class="info-value truncate"
              [attr.title]="selectedAnnexDetails?.definition"
            >
              {{ selectedAnnexDetails?.definition || "N/A" }}
            </span>
          </div>
        </div>
      </div>
    </div>
  </div> -->

  <!-- SPlit layout  -->
  <div class="layout">
    <!-- ============Left Panel=========================== -->
    <div class="left-panel">
        <!-- ==================== TERMS TAB CONTENT ==================== -->
        <div class="panel-header">
          <span>IMDRF Terms</span>
        </div>

          <div class="panel-body">

            <!-- Sticky Search -->
            <div class="search-wrapper">
              <div class="search-container">
                <mat-form-field appearance="outline" class="search-input">
                  <mat-label>Search Terms</mat-label>

                  <input
                    matInput
                    type="text"
                    [(ngModel)]="searchQuery"
                    placeholder="Search Code/terms..."
                    (keyup.enter)="onSearchChange()"
                  />

                  <button
                    mat-icon-button
                    matSuffix
                    (click)="onSearchChange()"
                  >
                    <mat-icon>search</mat-icon>
                  </button>

                  <button
                    mat-icon-button
                    matSuffix
                    *ngIf="searchQuery?.trim()"
                    (click)="clearSearch()"
                  >
                    <mat-icon>close</mat-icon>
                  </button>
                </mat-form-field>
              </div>
            </div>

            <!-- Scrollable Tree -->
            <div class="tree-container">

                  <div
                    *ngIf="treeData.length === 0"
                    class="loading-message"
                  >

                    <ng-container *ngIf="searchQuery?.trim(); else loadingState">
                      No matching terms found
                    </ng-container>

                    <ng-template #loadingState>
                      Loading Annex terms...
                    </ng-template>

                  </div>

              <p-tree
                *ngIf="treeData.length > 0"
                [value]="treeData"
                selectionMode="single"
                (onNodeSelect)="onNodeSelect($event)"
                (onNodeExpand)="onNodeExpand($event)"
                class="meddra-tree"
              >
                <ng-template let-node pTemplate="default">
                  <div
                    class="tree-node-content"
                    [class]="'tree-node-content level-' + (node.data?.hierarchyLevel || 0)"
                    [matTooltip]="node.label"
                  >
                  <div class="tree-label-wrapper">

                    <span
                      class="tree-code-chip"
                      [class]="'tree-code-chip level-chip-' + (node.data?.hierarchyLevel || 0)"
                    >
                      {{ node.data?.code }}
                    </span>

                    <span class="tree-label">
                      {{ node.data?.name }}
                    </span>

                  </div>
                  </div>
               </ng-template>
              </p-tree>

            </div>
          </div>
    </div>
<!-- ================Right Panel=========================== -->

        <div class="right-panel">
          <div class="panel-header" style="display: flex; align-items: center; justify-content: space-between; padding: 8px 12px;">
            <span style="font-size: 16px; font-weight: 600"> Results </span>
          </div>
                        <!-- ==================== PANEL BODY - AG Grid Container ==================== -->
                <div class="panel-body ag-grid-container">
                  <ag-grid-angular
                      class="ag-theme-balham terms-grid"
                      style="height: 100%;width: 100%;"
                      [gridOptions]="termsGridOptions"
                      [rowData]="filteredTableData"
                      [columnDefs]="columnDefs"
                      [rowSelection]="'single'"
                      [pagination]="true"
                      [paginationPageSize]="10"
                      (gridReady)="onGridReady($event)"
                      (rowSelected)="onGridRowSelected($event)"
                      (selectionChanged)="onGridSelectionChanged()"
                      [animateRows]="true"
                      [components]="components"
                      [rowHeight]="35"
                      [headerHeight]="35"
                      [enableBrowserTooltips]="true"
                      [floatingFiltersHeight]="45">
                    >
                    </ag-grid-angular>
                </div>
        </div>

  </div>

</div>
